module.exports = __webpack_public_path__ + "img/124.43544caa.png";